import React from 'react';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';

import { Label } from 'core';
import { FormField } from 'core/components/form';
import { Card } from 'core/components/card';
import { NotificationCard } from 'core/components/notification-card';
import infoIcon from 'core/assets/svg/ic-info-dark.svg';

import useStyles from './changes-for-approval-section.styles';

const DescriptionOfPolicyChanges = () => {
  const classes = useStyles();

  return (
    <Card type="primary" className={classes.descriptionOfPolicyChangesContainer}>
      <Label type="darkGreenSmallBold">Speed up processing</Label>
      <p className={classes.pipChangeDescription}>
        For fastest service, please provide a detailed description of your policy changes below:
      </p>

      <Grid className={classes.descriptionOfPolicyChangesFormField}>
        <FormField
          mode="light"
          label=""
          placeholder="Description of policy changes (optional)"
          type="textarea"
          id="policyChangesDescription"
          name="policyChangesDescription"
          rows={4}
          ignoreGlobalDisabledState
        />
      </Grid>

      <NotificationCard
        type="light"
        icon={infoIcon}
        iconSize="icon16"
        className={clsx(classes.infoBox, classes.descriptionOfPolicyChangesInfoBox)}
      >
        <Label type="body3" className={classes.infoBoxText}>
          <strong>Important:</strong> Changes will not be applied until approved by the Branch underwriting processing
          team. Submitting additional endorsements will cancel this approval request and will require you to resubmit
          your changes.
        </Label>
      </NotificationCard>
    </Card>
  );
};

export default DescriptionOfPolicyChanges;
